import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeToManager } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetManager(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IChangeManagerSettingPayload) => {
            return settingChangeToManager(payload)
        },
        onSuccess: (data, variables: any) => {
            // Shared by the promote (role 'mng') and demote (role 'nrm') modals.
            posthog.capture(
                variables?.role === 'nrm'
                    ? 'member_demoted_to_normal'
                    : 'member_promoted_to_manager',
                {
                    fund_id: variables?.id ?? variables?.moneyPool,
                    poolship_id: variables?.poolShip,
                }
            )
            refetch()
            toast.success('کاربر با موفقیت مدیر شد')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action:
                    variables?.role === 'nrm'
                        ? 'demote_to_normal'
                        : 'promote_to_manager',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
